import request from '@/utils/request'

// 商品--接口

let ProductApi = {
    // 分类列表
    catList(data, errorback) {
        return request._post('/supplier/product.category/index', data, errorback);
    },
    // 分类添加
    catAdd(data, errorback) {
        return request._post('/supplier/product.category/add', data, errorback);
    },
    // 分类删除
    catDel(data, errorback) {
        return request._post('/supplier/product.category/delete', data, errorback);
    },
    // 分类修改
    catEdit(data, errorback) {
        return request._post('/supplier/product.category/edit', data, errorback);
    },

    // 单位列表
    unitList(data, errorback) {
        return request._post('/supplier/product.unit/index', data, errorback);
    },
    // 单位添加
    unitAdd(data, errorback) {
        return request._post('/supplier/product.unit/add', data, errorback);
    },
    // 单位删除
    unitDel(data, errorback) {
        return request._post('/supplier/product.unit/delete', data, errorback);
    },
    // 单位修改
    unitEdit(data, errorback) {
        return request._post('/supplier/product.unit/edit', data, errorback);
    },

    // 规格列表
    specList(data, errorback) {
        return request._post('/supplier/product.spec/index', data, errorback);
    },
    // 新增规格
    addSpec(data, errorback) {
        return request._post('/supplier/product.spec/addSpec', data, errorback);
    },
    // 删除规格
    specDel(data, errorback) {
        return request._post('/supplier/product.spec/specDel', data, errorback);
    },

    // 规格值列表
    getSpecValue(data, errorback) {
        return request._post('/supplier/product.spec/getSpecValue', data, errorback);
    },
    // 新增规格值
    addSpecValue(data, errorback) {
        return request._post('/supplier/product.spec/addSpecValue', data, errorback);
    },
    // 删除规格值
    specValueDel(data, errorback) {
        return request._post('/supplier/product.spec/specValueDel', data, errorback);
    },

    getSpecList(data, errorback) {
        return request._post('/supplier/product.spec/getSpecList', data, errorback);
    },

    // 规格选择列表--废弃
    chooseSpec(data, errorback) {
        return request._post('/supplier/data.product/spec', data, errorback);
    },

    // 商品列表
    productList(data, errorback) {
        return request._post('/supplier/product.product/index', data, errorback);
    },
    // 商品选择列表
    chooseLists(data, errorback) {
        return request._post('/supplier/data.product/lists', data, errorback);
    },
    // 新增商品
    addProduct(data, errorback) {
        return request._post('/supplier/product.product/add', data, errorback);
    },
    // 商品基础数据
    getBaseData(data, errorback) {
        return request._get('/supplier/product.product/add', data, errorback);
    },
    // 删除商品
    delProduct(data, errorback) {
        return request._post('/supplier/product.product/delete', data, errorback);
    },
    // 商品上下架
    handleProduct(data, errorback) {
        return request._post('/supplier/product.product/handle', data, errorback);
    },
    // 商品单独上下架
    handleOneProduct(data, errorback) {
        return request._post('/supplier/product.product/handleOne', data, errorback);
    },
    // 商品基础数据
    getEditData(data, errorback) {
        return request._get('/supplier/product.product/edit', data, errorback);
    },
    // 修改商品
    editProduct(data, errorback) {
        return request._post('/supplier/product.product/edit', data, errorback);
    },

    // 商品列表不带分页
    getList(data, errorback) {
        return request._post('/supplier/data.product/lists', data, errorback);
    },
    // 商品列表不带分页
    getActiveProductList(data, errorback) {
        return request._post('/supplier/plus.fans.product/lists', data, errorback);
    },
    // 商品评论列表
    getCommentList(data, errorback) {
        return request._post('/supplier/product.comment/index', data, errorback);
    },
    // 获取评论详情
    getComment(data, errorback) {
        return request._post('/supplier/product.comment/detail', data, errorback);
    },
    // 获取评论详情
    editComment(data, errorback) {
        return request._post('/supplier/product.comment/edit', data, errorback);
    },
    // 删除评论
    delComment(data, errorback) {
        return request._post('/supplier/product.comment/delete', data, errorback);
    },
    // 得到分类图片
    cateImage(data, errorback) {
        return request._post('/supplier/product.category/image', data, errorback);
    },
    // 修改状态
    changeStatus(data, errorback) {
        return request._post('/supplier/product.product/state', data, errorback);
    },

    // 套餐列表
    setmealProductList(data, errorback) {
        return request._post('/supplier/product.setmeal/index', data, errorback);
    },
    // 套餐基础数据
    getSetmealBaseData(data, errorback) {
        return request._get('/supplier/product.setmeal/add', data, errorback);
    },
    // 新增套餐
    addSetmealProduct(data, errorback) {
        return request._post('/supplier/product.setmeal/add', data, errorback);
    },
    // 商品基础数据
    getSetmealEditData(data, errorback) {
        return request._get('/supplier/product.setmeal/edit', data, errorback);
    },
    // 编辑商品
    editSetmealProduct(data, errorback) {
        return request._post('/supplier/product.setmeal/edit', data, errorback);
    },
    // 删除商品
    delSetmealProduct(data, errorback) {
        return request._post('/supplier/product.setmeal/delete', data, errorback);
    },
    // 修改套餐状态
    changeSetmealStatus(data, errorback) {
        return request._post('/supplier/product.setmeal/state', data, errorback);
    },

}

export default ProductApi;



// WEBPACK FOOTER //
// ./src/api/product.js